import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CorePipesModule } from "@core/pipes/pipes.module";
import { TranslateModule } from "@ngx-translate/core";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { ApprovalFlowComponent} from  "./approval-flow.component"
import { NgSelectModule } from "@ng-select/ng-select";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BlockUIModule } from "ng-block-ui";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { CoreDirectivesModule } from "@core/directives/directives";
import { CoreSidebarModule } from "@core/components";
import { ContentHeaderModule } from "app/layout/components/content-header/content-header.module";
import { CoreCardModule } from "@core/components/core-card/core-card.module";
import { IconsModule } from "app/components/icons";
@NgModule({
    declarations:[ApprovalFlowComponent],
    imports:[
        NgxDatatableModule,
        CommonModule,
        TranslateModule,
        CorePipesModule,
        NgSelectModule,
        FormsModule,
        BlockUIModule.forRoot(),
        NgbModule,
        CorePipesModule,
        CoreDirectivesModule,
        ContentHeaderModule,
        ReactiveFormsModule,
        IconsModule
        
    ],
    exports:[ApprovalFlowComponent]
})
export class ApprovalFlowModule{}
